import React, { useEffect, useState } from 'react';
import { getPhonePrefixes } from '../utils/phoneValidation';

export default function PhoneInput({
  value = '',
  onChange,
  placeholder = '05XXXXXXXX',
  required = false,
  digitsLabel = 'digits',
}) {
  const [prefixes, setPrefixes] = useState([]);
  const [selectedPrefix, setSelectedPrefix] = useState('');
  const [phoneDigits, setPhoneDigits] = useState('');
  const [maxLength, setMaxLength] = useState(9);

  useEffect(() => {
    getPhonePrefixes()
      .then((configs) => {
        setPrefixes(configs);
        if (configs.length > 0) {
          setSelectedPrefix((prev) => prev || configs[0].prefix);
          setMaxLength(configs[0].length);
        }
      })
      .catch((err) => console.error('Error loading prefixes:', err));
  }, []);

  useEffect(() => {
    if (!value || prefixes.length === 0) return;
    const matched = prefixes.find((p) => value.startsWith(p.prefix));
    if (matched) {
      setSelectedPrefix(matched.prefix);
      setPhoneDigits(value.substring(matched.prefix.length));
      setMaxLength(matched.length);
    }
  }, [value, prefixes]);

  const handlePrefixChange = (e) => {
    const newPrefix = e.target.value;
    setSelectedPrefix(newPrefix);
    const config = prefixes.find((p) => p.prefix === newPrefix);
    if (!config) return;
    setMaxLength(config.length);
    const trimmed =
      phoneDigits.length > config.length
        ? phoneDigits.substring(0, config.length)
        : phoneDigits;
    setPhoneDigits(trimmed);
    onChange(newPrefix + trimmed);
  };

  const handleDigitsChange = (e) => {
    let digits = e.target.value.replace(/\D/g, '');
    if (digits.length > maxLength) digits = digits.substring(0, maxLength);
    setPhoneDigits(digits);
    onChange(selectedPrefix + digits);
  };

  return (
    <div className="phone-input-container">
      <select
        className="phone-prefix-select"
        value={selectedPrefix}
        onChange={handlePrefixChange}
        required={required}
        aria-label="Country code"
      >
        {prefixes.map((config) => (
          <option key={config.prefix} value={config.prefix}>
            {config.prefix} ({config.country})
          </option>
        ))}
      </select>
      <input
        type="tel"
        className="phone-digits-input"
        value={phoneDigits}
        onChange={handleDigitsChange}
        placeholder={placeholder}
        required={required}
        maxLength={maxLength}
        inputMode="numeric"
      />
      <span className="phone-input-hint">
        {maxLength} {digitsLabel}
      </span>
    </div>
  );
}
